import React, { Component } from 'react';
import { get, post } from 'axios';
import Notifications, {notify} from 'react-notify-toast';
import { ToastContainer, toast } from 'react-toastify';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { inject, observer } from 'mobx-react';
import Modal from 'react-bootstrap4-modal';
import ModalBookingServices from './ModalBookingServices';
import ModalBookingServices2 from './ModalBookingServices2';
import 'react-toastify/dist/ReactToastify.css';

let toastParams = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: false,
  pauseOnHover: false,
  draggable: false,
};

@inject('userStore')
@observer
class BookingServices extends Component {
    constructor(props){
        super(props);
        this.state = {
            participant_list:[],
            service_list:[],
            bus_service_list:[],
            quickviewVisible:false,
            participant:null,
            addParticipant:false,
            modalVisible:false,
            participant_role_list:[],
            formData:{
                participant_role_id:"6",
                first_name:"",
                last_name:""
            }

        }
        this.selectParticipant = this.selectParticipant.bind(this);
        this.participantServices = this.participantServices.bind(this);
        this.assignService = this.assignService.bind(this);
        this.removeService = this.removeService.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.addParticipant = this.addParticipant.bind(this);
        this.deleteService = this.deleteService.bind(this);
    }

    handleInputChange(e) {
        let formData = Object.assign({}, this.state.formData);
        formData[e.target.name] = e.target.value;
        this.setState({formData});
    }

    modalBackgroundClicked(){
        this.setState({
            modalVisible:!this.state.modalVisible
        });
    }


    addParticipant(){
      let input_ref = this.first_name;
      post('/v2/save/participant', {booking_hash_id: this.props.booking.hash_id, mode:'ADD', first_name:this.state.formData.first_name, last_name:this.state.formData.last_name, participant_role_id:this.state.formData.participant_role_id},{
          auth: {username: this.props.userStore.token}
      }).then((res) => {
        if (res.data.errors === 0){
          // reload the participant_list from response
          this.setState({
            participant_list:res.data.participant_list,
            formData:{
              participant_role_id:"6",
              first_name:"",
              last_name:""
            }
          },()=>input_ref.focus())
          toast.success(res.data.message, toastParams);
        } else {
          toast.error('Error occurred: ' + res.data.message, toastParams);
        }
      }).catch((error) => {
        console.log(error);
        return error;
      });
    }

    addService = (service) => {
      if (service.quantity > 0){
        post('/v2/save/service', {hash_id: this.props.booking.hash_id, mode:'ADD', service:service},{
          auth: {username: this.props.userStore.token}
        }).then((res) => {
          if (res.data.errors === 0){
            this.setState({
              service_list:res.data.service_list
            })
            this.props.addServiceHandler(service);
            toast.success('Added Service - Be sure to make Invoice Adjustments', toastParams);
          } else {
            toast.error('Error occurred: ' + res.data.message, toastParams);
          }
        }).catch((error) => {
          console.log(error);
          return error;
        });
      } else {
        toast.error('Quantity must be greater than 0', toastParams);
      }
    }


    deleteService(service){
      if (window.confirm('Are you sure you want to delete this service from the event?') === true){
        post('/v2/save/service', {hash_id: this.props.booking.hash_id, mode:'DELETE', bk_service_id:service.id},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
                let temp_service_list = Object.assign([], this.state.service_list);
                let index = this.state.service_list.findIndex(x => x.id === service.id);
                temp_service_list.splice(index, 1);
                this.setState({
                  service_list:temp_service_list
                })
                this.props.deleteServiceHandler(service);
                toast.success('Deleted Service - Be sure to make Invoice Adjustments', toastParams);
            } else {
                toast.error('Error occurred: ' + res.data.message, toastParams);
            }
        }).catch((error) => {
            console.log(error);
            return error;
        });
      }
    }

    removeService(service){
        post('/v2/save/service', {hash_id: this.props.booking.hash_id, mode:'REMOVE', bk_service_id:service.id},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
                service.bk_client_user_id = null;
                this.forceUpdate()
                notify.show('Removed Service', "success", 4000);
            } else {
                notify.show('Error occurred: ' + res.data.message, "error", 4000);
            }
        }).catch((error) => {
            console.log(error);
            return error;
        });
    }

    assignService(service, participant){
        post('/v2/save/service', {hash_id: this.props.booking.hash_id, mode:'ASSIGN', bk_service_id:service.id, bk_client_user_id:participant.id},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
                service.bk_client_user_id = participant.id;
                this.forceUpdate()
                notify.show('Added Service', "success", 4000);
            } else {
                notify.show('Error occurred: ' + res.data.message, "error", 4000);
            }
        }).catch((error) => {
            console.log(error);
            return error;
        });
    }

    deleteParticipant = (participant) => {
        if (window.confirm("Are you sure you want to delete?")){
          post('/v2/save/participant', {mode:'REMOVE', bk_client_user_id:participant.id},{
              auth: {username: this.props.userStore.token}
          }).then((res) => {
              if (res.data.errors === 0){
                this.setState({
                  participant_list:res.data.participant_list,
                  service_list:res.data.service_list
                })
                notify.show('Removed Participant', "success", 4000);
              } else {
                notify.show('Error occurred: ' + res.data.message, "error", 4000);
              }
          }).catch((error) => {
              console.log(error);
              return error;
          });
        }
    }

    componentDidMount(){
        this.setState({
            service_list:this.props.booking.service_list,
            participant_list:this.props.booking.participant_list,
            participant_role_list:this.props.booking.participant_role_list,
            bus_service_list:this.props.bus_service_list
        });
    }

    participantServices(participant){
        var result = this.state.service_list.filter(service => {
            return service.bk_client_user_id === participant.id
        });
        return result
    }

    selectParticipant(participant){
        this.setState({
            participant:participant,
            quickviewVisible:true
        })
    }

    showParticipantAdd = () => {
      this.setState({
        quickviewVisible:!this.state.visible,
        addParticipant:true,
        participant:null
      },()=>this.first_name.focus())
    }

    render() {
        const {backHandler, booking} = this.props;
        var unassignedCount = this.state.service_list.filter(function(service) { return !service.bk_client_user_id && !service.is_preview }).length;
        if (!booking) return <div className="alert alert-danger">No Booking Loaded</div>;
        return (
            <React.Fragment>
            <ToastContainer
              position="top-center"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick={false}
              rtl={false}
              pauseOnVisibilityChange={false}
              draggable={false}
              pauseOnHover={false}
            />
            <Modal visible={this.state.modalVisible} onClickBackdrop={() => this.modalBackgroundClicked()} dialogClassName="modal-lg w-900px">
                <div className="modal-header">
                    <h4 className="modal-title">Add Services</h4>
                    <button type="button" className="close" onClick={() => this.modalBackgroundClicked(null)} aria-label="Close">
                      <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div className="modal-body h-600px">
                <PerfectScrollbar>
                  <ModalBookingServices2 booking={booking} service_list={this.state.bus_service_list} addServiceHandler={this.addService}/>
                </PerfectScrollbar>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={() => this.modalBackgroundClicked(null)}>
                      Close
                    </button>
                </div>
            </Modal>
            <Notifications options={{wrapperId:'service-notifications'}} />
            <div className="main-content pt-0">
                <header className="header-transparent">
                    <div className="header-info mb-0 mt-20 p-0">
                        <div className="left">
                            <h2 className="header-title">Participants and Services <small style={{display:'inline'}}>{booking.event_name}</small></h2>
                        </div>
                        <div className="right gap-items-2">
                            <a className="btn btn-secondary btn-square btn-round" onClick={backHandler}><i className="fa fa-remove"></i></a>
                        </div>
                    </div>
                </header>
                <div className="card">
                    <h4 className="card-title">
                      <strong>Participant List</strong>
                      <div className="btn-group pull-right">
                        <button className="btn btn-success" onClick={this.showParticipantAdd}><i className="fa fa-user-plus"></i> Add Participant</button>
                        <button className="btn btn-success" onClick={()=>this.setState({modalVisible:!this.state.modalVisible})}><i className="fa fa-plus"></i> Add Services</button>
                      </div>
                    </h4>
                    <div className="media-list media-list-hover media-list-divided scrollable ps-container ps-theme-default ps-active-y">
                    {this.state.participant_list.map((participant, index) =>
                        <div className="media media-single" key={index}>
                            <div className="media-body"  onClick={()=>this.selectParticipant(participant)}>
                                <h6><a href="#">{participant.full_name}</a>{this.participantServices(participant).length > 0 ? <span className="badge badge-pill badge-info ml-10">{this.participantServices(participant).length}</span> : null}</h6>
                                <small className="text-fader">{participant.sys_client_role}</small>
                            </div>
                            <div className="media-right">
                              <div className="btn-group">
                                <button className="btn btn-sm btn-bold btn-round btn-outline btn-danger" onClick={()=>this.deleteParticipant(participant)}> Delete</button>
                                <button className="btn btn-sm btn-bold btn-round btn-outline btn-primary" onClick={()=>this.selectParticipant(participant)}> Assign Services</button>
                              </div>
                            </div>
                        </div>
                    )}
                    {unassignedCount > 0 ?
                        <div className="media media-single">
                            <div className="media-body">
                                <h6 className="text-danger">Unassigned Services <span className="badge badge-pill badge-danger ml-10">{unassignedCount}</span></h6>
                            </div>
                        </div>
                    : null
                    }
                    </div>
                    <footer className="card-footer">
                        {booking.participant_instructions ?
                          <React.Fragment>
                          <strong>Participant Instructions</strong><br/>
                          <blockquote className="blockquote pull-left"><p>{booking.participant_instructions}</p></blockquote>
                          </React.Fragment>
                        : null}
                    </footer>
                </div>
            </div>
            <div className={this.state.quickviewVisible ? "quickview quickview-lg reveal" : "quickview quickview-lg"}>
            {this.state.participant ?
                <React.Fragment>
                <header className="quickview-header">
                    <p className="quickview-title lead fw-400">Services for {this.state.participant.full_name}</p>
                    <span className="close" onClick={() => this.setState({quickviewVisible:false})}><i className="ti-close"></i></span>
                </header>
                <PerfectScrollbar>
                <div className="quickview-body">
                    <div className="quickview-block form-type-material">
                        <div className="card card-bordered">
                            <h3 className="card-title card-title-bold">Assigned Services</h3>
                            <div className="media-list media-list-hover media-list-divided">
                            {this.state.service_list.map((service, index) =>
                                service.bk_client_user_id === this.state.participant.id && !service.is_preview ?
                                    <div key={index} className="media media-single">
                                        <div className="media-body">
                                          <strong>{service.name}</strong>
                                        </div>
                                        <div className="media-right">
                                          <button className="btn btn-float btn-sm btn-danger" onClick={() => this.removeService(service)}><i className="fa fa-minus"></i></button>
                                        </div>
                                    </div>
                                : null
                            )}
                            </div>
                        </div>
                        <div className="card card-bordered">
                            <h3 className="card-title card-title-bold">Available Services</h3>
                            <div className="media-list media-list-hover media-list-divided">
                            {this.state.service_list.map((service, index) =>
                                !service.bk_client_user_id && !service.is_preview ?
                                    <div key={index} className="media media-single">
                                        <div className="media-body">
                                          <strong>{service.name}</strong>
                                        </div>
                                        <div className="media-right">
                                          <button className="btn btn-float btn-sm btn-danger mr-10" onClick={() => this.deleteService(service)}><i className="fa fa-close"></i></button>
                                          <button className="btn btn-float btn-sm btn-success" onClick={() => this.assignService(service, this.state.participant)}><i className="fa fa-plus"></i></button>
                                        </div>
                                    </div>
                                : null
                            )}
                            </div>
                        </div>
                    </div>
                </div>
                </PerfectScrollbar>
                <footer className="p-12 text-center">
                  <div className="btn-group btn-block btn-group-vertical">
                      <button className="btn btn-lg btn-outline btn-block btn-info" onClick={() => this.setState({quickviewVisible:false})}><i className="fa fa-fw fa-close"></i> Close</button>
                  </div>
                </footer>
                </React.Fragment>
                : this.state.addParticipant ?
                <React.Fragment>
                <header className="quickview-header">
                    <p className="quickview-title lead fw-400">Add Participant</p>
                    <span className="close" onClick={() => this.setState({quickviewVisible:false,addParticipant:false})}><i className="ti-close"></i></span>
                </header>
                <PerfectScrollbar>
                <div className="quickview-body ps-container ps-theme-default">
                    <div className="quickview-block">
                        <br/>
                        <div className="form-group">
                            <input className="form-control" ref={inputEl => (this.first_name = inputEl)} type="text" placeholder="First Name" name="first_name" value={this.state.formData.first_name} onChange={this.handleInputChange}/>
                        </div>
                        <div className="form-group">
                            <input className="form-control" type="text" placeholder="Last Name" name="last_name" value={this.state.formData.last_name} onChange={this.handleInputChange}/>
                        </div>
                        <div className="form-group">
                            <select className="form-control" name="participant_role_id" value={this.state.formData.participant_role_id} onChange={this.handleInputChange}>
                            {this.state.participant_role_list.map((role, index) =>
                                <option key={index} value={role.id}>{role.name}</option>
                            )}
                            </select>
                        </div>
                        <div className="form-group">
                          <button className="btn btn-primary pull-right" type="submit" onClick={this.addParticipant}>Add Participant</button>
                        </div>
                    </div>
                </div>
                </PerfectScrollbar>
                <footer className="quickview-footer flex-row-reverse">
                    <button className="btn btn-primary" type="submit" onClick={this.addParticipant}>Add Participant</button>
                    <button className="btn btn-secondary" type="button" onClick={() => this.setState({quickviewVisible:false})}>Cancel</button>
                </footer>
                </React.Fragment>
                :
                <div>Loading</div>
            }
            </div>
            </React.Fragment>
        )
  }
}

export default BookingServices;



// WEBPACK FOOTER //
// ./src/components/business/BookingServices.js